module.exports = __webpack_public_path__ + "img/info-icon.204f728c.svg";